import {
    GET_CONSIGNMENT_DETAILS,
    GET_CONSIGNMENT_DETAILS_SUCCESS,
    GET_CONSIGNMENT_DETAILS_FAILURE,
    USAGE_ATTACHMENT_UPLOAD,
    USAGE_ATTACHMENT_UPLOAD_FAILURE,
    USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    DELETE_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_ATTACHMENT_REQUEST_FAILURE,
    RESET_PO_ATTACHMENT,
    GET_IMAGE_PO_PREVIEW,
    GET_IMAGE_PO_PREVIEW_SUCCESS,
    GET_IMAGE_PO_PREVIEW_FAILURE,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    consignmentDetails: {
        myCaseRef: '',
    },
    myCaseRefId: null,
    myCaseResourceType: null,
    isdeletionDone: false,
    isUsageAttachmentUploaded: false,
    poTissueImageDetails: '',
    poNonTissueImageDetails: '',
    poImagePreviewLoader: false,
    poImagePreviewDetails: null,
    poImageUploadLoader: false,
};

const consignmentDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CONSIGNMENT_DETAILS:
            return {
                ...state,
                ...initialState,
            };
        case GET_CONSIGNMENT_DETAILS_SUCCESS:
            return {
                ...state,
                consignmentDetails: {
                    myCaseRef: action.myCaseRef,
                },
            };
        case GET_CONSIGNMENT_DETAILS_FAILURE:
            return {
                ...state,
                consignmentDetails: {
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        case USAGE_ATTACHMENT_UPLOAD:
            return {
                ...state,
                poImageUploadLoader: true,
            };
        case USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE:
            return {
                ...state,
                poNonTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE:
            return {
                ...state,
                poTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case USAGE_ATTACHMENT_UPLOAD_FAILURE:
            return {
                ...state,
                isUsageAttachmentUploaded: false,
                poImageUploadLoader: false,
            };
        case DELETE_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                poTissueImageDetails: action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poTissueImageDetails,
                poNonTissueImageDetails: !action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poNonTissueImageDetails,
            };
        case RESET_PO_ATTACHMENT:
            return {
                ...state,
                poTissueImageDetails: '',
                poNonTissueImageDetails: '',
            };
        case DELETE_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                isdeletionDone: false,
            };
        case GET_IMAGE_PO_PREVIEW:
            return {
                ...state,
                poImagePreviewLoader: true,
            };
        case GET_IMAGE_PO_PREVIEW_SUCCESS:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: action.payload,
            };
        case GET_IMAGE_PO_PREVIEW_FAILURE:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: null,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentDetailsKey',
        storage: storage,
    },
    consignmentDetailsReducer
);
